import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

const logConfig = {
    logUrl: "/api/log",
    defaultLogLevel: "Debug",
    writeToConsole: true,
    Debug: "Debug",
    Warning: "Warning",
    Information: "Information",
    Error: "Error",
    Critical: "Critical",
    wholeMessage: "Message: {0} Exception Message: {1} Stack: {2}",
    bufferMax: 10,
    flushLevel: "Error"
};
const logLevels = {
    Debug: 1,
    Information: 2,
    Warning: 3,
    Error: 4,
    Critical: 5
};
let buffer = [];

function writelog(level, message) {
    level = level || logConfig.defaultLogLevel;

    if (logLevels[level] >= logLevels[logConfig.defaultLogLevel]) {
        buffer.push({
            "Level": logLevels[level],
            "Message": message
        });
    }
    if (buffer.length >= logConfig.bufferMax || logLevels[level] >= logLevels[logConfig.flushLevel]) {
        flushbuffer();
    }
}
function logToConsole(message) {
    if (logConfig.writeToConsole) console.log(message);
}
function flushbuffer() {
    if (buffer.length === 0) {
        return;
    }

    dataaccess.post({ url: logConfig.logUrl, data: buffer });
    buffer = [];
}
function debug(message) {
    writelog(logConfig.Debug, message);

    logToConsole(message);
}
function debugException(ex, message) {
    debug($.format(logConfig.wholeMessage, [message, ex.message, ex.stack]));
}
function warn(message) {
    writelog(logConfig.Warning, message);

    logToConsole(message);
}
function warnException(ex, message) {
    warn($.format(logConfig.wholeMessage, [message, ex.message, ex.stack]));
}
function info(message) {
    writelog(logConfig.Information, message);

    logToConsole(message);
}
function infoException(ex, message) {
    info($.format(logConfig.wholeMessage, [message, ex.message, ex.stack]));
}
function error(message) {
    writelog(logConfig.Error, message);

    logToConsole(message);
}
function errorException(ex, message) {
    error($.format(logConfig.wholeMessage, [message, ex.message, ex.stack]));
}
function critical(message) {
    writelog(logConfig.Critical, message);

    logToConsole(message);
}
function criticalException(ex, message) {
    critical($.format(logConfig.wholeMessage, [message, ex.message, ex.stack]));
}

export const logger = {
    error: error,
    errorException: errorException,
    critical: critical,
    criticalException: criticalException,
    infoException: infoException,
    info: info,
    warn: warn,
    warnException: warnException,
    debug: debug,
    debugException: debugException
};